import styled from 'styled-components'

const Container = styled.div`
  color: #1a1a1a;
  
  .form--container {
    width: 100%;
    max-width: 600px;
    padding: 2rem;
    background: white;
    border-radius: 12px;
    color: #1a1a1a;

    header {
      margin-bottom: 2rem;
      text-align: center;

      h2 {
        font-size: 1.8rem;
        color: #1a1a1a;
        margin-bottom: 0.5rem;
        font-weight: 600;
      }

      p {
        color: #666;
        font-size: 0.95rem;
      }
    }

    .progress-indicator {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 2.5rem;
      gap: 1rem;

      .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
        flex: 1;

        .step-number {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #e0e0e0;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        span {
          font-size: 0.85rem;
          color: #999;
          transition: color 0.3s ease;
        }

        &.active {
          .step-number {
            background: #ff6b35;
            color: white;
          }

          span {
            color: #1a1a1a;
            font-weight: 500;
          }
        }
      }

      .step-line {
        flex: 1;
        height: 2px;
        background: #e0e0e0;
        margin: 0 0.5rem;
        margin-bottom: 1.5rem;
      }
    }

    form {
      .form-step {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
      }

      /* Ensure all inputs have dark text */
      input, textarea, select {
        color: #1a1a1a !important;
        background: white !important;
      }

      /* Ensure all labels have dark text */
      label {
        color: #333 !important;
      }

      .input-group {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #333 !important;
        }

        textarea {
          padding: 0.75rem;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 0.95rem;
          font-family: inherit;
          resize: vertical;
          transition: border-color 0.3s ease;
          color: #1a1a1a !important;
          background: white !important;

          &:focus {
            outline: none;
            border-color: #ff6b35;
          }

          &::placeholder {
            color: #999;
          }
        }
      }

      .password-input-wrapper {
        position: relative;
        display: flex;
        align-items: center;

        input {
          flex: 1;
          padding: 0.75rem;
          padding-right: 3rem;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 0.95rem;
          transition: border-color 0.3s ease;
          color: #1a1a1a !important;
          background: white !important;

          &:focus {
            outline: none;
            border-color: #ff6b35;
          }

          &::placeholder {
            color: #999;
          }
        }

        .password-toggle {
          position: absolute;
          right: 0.75rem;
          background: none;
          border: none;
          color: #666;
          cursor: pointer;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 0.3s ease;

          &:hover {
            color: #ff6b35;
          }

          svg {
            font-size: 1.1rem;
          }
        }
      }

      .error-message {
        color: #dc3545;
        font-size: 0.85rem;
        margin-top: -0.75rem;
        padding-left: 0.25rem;
      }

      .button-row {
        display: flex;
        gap: 1rem;
        margin-top: 1.5rem;

        button {
          flex: 1;
        }

        .btn-secondary {
          background: #f5f5f5;
          color: #333;

          &:hover {
            background: #e0e0e0;
          }
        }
      }

      button[type='submit'],
      button[type='button'] {
        margin-top: 0.5rem;
      }
    }
  }

  @media (max-width: 768px) {
    .form--container {
      padding: 1.5rem;

      header {
        h2 {
          font-size: 1.5rem;
        }
      }

      .progress-indicator {
        .step {
          span {
            font-size: 0.75rem;
          }

          .step-number {
            width: 35px;
            height: 35px;
          }
        }
      }
    }
  }
`

export default Container
